import { NextSeo } from "next-seo"
import getConfig from "next/config"
import { useRouter } from "next/router"

import image, { CATEGORY_BANNER_BIG } from "lacinetek-common/src/images"
import { hideInProduction } from "lacinetek-common/src/models/category"

import isBrowser from "lib/tools/is-browser"
import { useCountry } from "lib/country"
import { FETCH_CORPUS } from "lib/graphql"
import Gtm from "lib/gtm"
import { useTranslation } from "lib/i18n/translation"
import { getPageCanonicalUrl } from "lib/tools/urls"

import { Query } from "components/common"
import { Header,List } from "components/selection/[id]"
import { Selections } from "components/home"
import { baseSelection } from "components/common/skeleton"

import NotFound from "../../404"

const { publicRuntimeConfig } = getConfig()

const Selection = ({slug, status}) => {
	const { c } = useTranslation("common")
	const router = useRouter()
	const url = router ? router.asPath : null

	return (
		<>
			<Gtm pageType="Sélection" pagePath={url} pageTitle={c("selection")} />
			<Query
				query={FETCH_CORPUS}
				options={{variables: { query: `linkRewrite.value: (${slug})`}}}
				renderLoading={() => <Content selection={baseSelection} loading={true} />}
			>
				{({cms: { categories: { items: [selection] }}}) => {
					if (
						!selection
						|| hideInProduction(selection, publicRuntimeConfig.lacinetekEnv)
					) {
						if (!isBrowser && status) {
							status(404)
						}

						return <NotFound />
					}

					return (
					<Content selection={selection} />
				)}}
			</Query>
		</>
	)
}

const Content = ({selection, loading}) => {
	const { asPath } = useCountry()
	const router = useRouter()
	const canonical = getPageCanonicalUrl(router, asPath)

	return (
		<>
			{ loading
				? null
				: <NextSeo
						title={selection.metaTitle || selection.name}
						description={selection.metaDescription || selection.descriptionShort}
						keywords={selection.metaKeywords}
						canonical={canonical}
						openGraph={{
							title: selection.metaTitle || selection.name,
							description: selection.metaDescription || selection.descriptionShort,
							url: canonical,
							images: [{ url: image(selection, CATEGORY_BANNER_BIG) }],
							image: {url: image(selection, CATEGORY_BANNER_BIG)}
						}}
					/>
			}
			<Header selection={selection} loading={loading} />
			<List selection={selection} loading={loading} />
			<Selections key={`sub-selection-for-${selection.id}`} title={true} current={selection} />
		</>
	)
}

Selection.getInitialProps = async (ctx) => {
	const id = ctx.query.id.split('.')

	return {
		slug: id[0],
		status: ctx.res ? ctx.res.status.bind(ctx.res) : undefined
	}
}

export default Selection
